import templateStr from 'text!./job-underwriting-issues.html';
import _ from 'underscore';
import uwutil from 'edge/gateway/util/UWUtil';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            job: '=',
            jobService: '=',
            edit: '=',
            withdraw: '=',
            canWithdraw: '=',
            canContinue: '='
        },
        controller: ['$scope', '$q', 'ModalService', 'InsuranceSuiteMetadata', 'TranslateService', 'UserInfoService', function ($scope, $q, ModalService, InsuranceSuiteMetadata, TranslateService, UserInfoService) {
            $scope.noteForUW = { 'note': '' };
            $scope.referToUW = false;
            $scope.isAgent = UserInfoService.isAgent();

            var blockingPoints = InsuranceSuiteMetadata.get('pc').types.getTypelist('UWIssueBlockingPoint');

            if (!$scope.canContinue) {
                $scope.canContinue = true;
            }

            $scope.openReferToUWForm = function () {
                $scope.referToUW = true;
                $scope.noteForUW.note = '';
            };

            $scope.closeReferToUWForm = function () {
                $scope.referToUW = false;
                $scope.noteForUW.note = '';
            };

            $scope.referQuoteToUnderWriter = function () {
                $scope.noteForUW.note = $scope.noteForUW.note === '' ? null : $scope.noteForUW.note;
                $scope.lockAndSendForReviewPromise = $scope.jobService.referToUnderwriter($scope.job.jobNumber, $scope.noteForUW.note).then(function (job) {
                    $scope.job = job;
                    $scope.$emit('activitiesUpdated');
                }, function () {
                    ModalService.showError('gateway.views.modal.Error', 'gateway.views.job-uwissues.There was an error sending the job for review');
                });
                $scope.closeReferToUWForm();
            };

            $scope.getUWStatus = function (issue) {
                var status = blockingPoints.getCode(issue.currentBlockingPoint);
                return issue.currentBlockingPoint === 'NonBlocking' && issue.hasApprovalOrRejection ? TranslateService.instant('gateway.views.job-uwissues.Approved') : status.name;
            };

            $scope.showUWIssuesAlert = function () {
                return $scope.uwutil.hasUwIssues && !['Bound', 'Withdrawn'].includes($scope.job.statusCode);
            };

            $scope.showMessageBox = function () {
                return $scope.job ? !$scope.job.isEditLocked && $scope.referToUW && $scope.job.statusCode !== 'Withdrawn' && $scope.uwutil.uwIssuesAreBlocking : false;
            };

            $scope.showUWIssuesTriggeredMsg = function () {
                return $scope.showUWIssuesAlert() && !$scope.job.isEditLocked && $scope.uwutil.uwIssuesAreBlocking && !$scope.uwutil.uwIssuesHaveBeenInspectedByUW && ['Draft', 'Quoted'].includes($scope.job.statusCode);
            };

            $scope.showReferredToUWMsg = function () {
                return $scope.showUWIssuesAlert() && $scope.job.isEditLocked && $scope.uwutil.hasUwIssues && $scope.job.createdByMe;
            };

            $scope.showUWIssuesRejectedMsg = function () {
                return $scope.showUWIssuesAlert() && !$scope.job.isEditLocked && $scope.uwutil.uwIssuesHaveBeenInspectedByUW;
            };

            $scope.showUWIssuesApprovedMsg = function () {
                return $scope.showUWIssuesAlert() && !$scope.job.isEditLocked && !$scope.uwutil.uwIssuesAreBlocking;
            };

            $scope.getUWIssueStatusByOffering = function (uwIssue, offering) {
                var currentUWIssue = offering ? _.find(uwIssue.onOfferings, function (offer) {
                    return offer.offering === offering;
                }) : uwIssue;

                var displayStatus = TranslateService.instant('gateway.views.job-uwissues.N/A');
                if (!currentUWIssue) {
                    return displayStatus;
                }

                if (currentUWIssue.currentBlockingPoint) {
                    displayStatus = blockingPoints.getCode(currentUWIssue.currentBlockingPoint).name;
                }

                return currentUWIssue.currentBlockingPoint === 'NonBlocking' && currentUWIssue.hasApprovalOrRejection ? TranslateService.instant('gateway.views.job-uwissues.Approved') : displayStatus;
            };

            $scope.theJobStateForLock = function () {
                return ['Withdrawn'].includes($scope.job.statusCode);
            };

            $scope.$watch('job', function () {
                $scope.uwutil = uwutil($scope.job, $scope.isAgent);
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/JobUnderwritingIssuesDirective/JobUnderwritingIssues.js
// module id = 1749
// module chunks = 0